import { render } from "./WidgetBillingDetails.vue?vue&type=template&id=c67b4cae&ts=true"
import script from "./WidgetBillingDetails.vue?vue&type=script&lang=ts"
export * from "./WidgetBillingDetails.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__